import { DEFAULT_IMAGE_TYPE, } from "./vod-images";
import { DEFAULT_MAX_CONCURRENT_STREAMS, RIGHTS_OPEN_ENDED, WHOLE_MARKET, } from "./content-rights";
import { parseAssetYear } from "./vod-title";
export const REPLACED_COLLECTIONS = [
    "medias",
    "images",
    "localizedInfo",
    "contentRights",
    "keywords",
    "contributors",
    "parentalRatings",
];
export function emptyMediaDraft(type) {
    return {
        mediaId: null,
        type,
        name: "",
        videoResolution: "HD",
        durationMillis: "",
        videoWidth: "",
        videoHeight: "",
        multiChannelAudio: false,
        spokenLanguage: "",
        audioLanguages: [],
        subtitleLanguages: [],
        hardOfHearing: false,
        mediaResources: [],
    };
}
export function emptyResourceDraft() {
    return {
        mediaResourceId: null,
        type: "native",
        protocol: "hls",
        url: "",
        isEncrypted: false,
    };
}
export function emptyRightsDraft(marketCountry = "", from = new Date()) {
    return {
        contentRightsId: null,
        marketCountry,
        region: WHOLE_MARKET,
        availableFrom: from.toISOString(),
        availableTo: RIGHTS_OPEN_ENDED,
        encrypted: false,
        maxConcurrentStreams: String(DEFAULT_MAX_CONCURRENT_STREAMS),
        allowedToDownload: false,
    };
}
export function emptyImageDraft(language) {
    return {
        imageId: null,
        language,
        type: DEFAULT_IMAGE_TYPE,
        url: "",
        source: "",
        width: "",
        height: "",
    };
}
export function emptyAssetDraft(type, sourceType = type === "channel" ? "live" : "vod") {
    return {
        assetId: null,
        type,
        sourceType,
        externalId: "",
        originalTitle: "",
        providerId: "",
        originalLanguage: "",
        countryOfOrigin: "",
        copyrightInfo: "",
        eidrId: "",
        studio: "",
        productionYear: "",
        duration: "",
        seriesId: "",
        seasonId: "",
        seasonNumber: "",
        episodeNumber: "",
        keywords: [],
        genreIds: [],
        tagIds: [],
        localizedInfo: [],
        images: [],
        medias: [],
        contentRights: [],
        parentalRatings: [],
        contributors: [],
    };
}
function numberText(value) {
    return typeof value === "number" && Number.isFinite(value)
        ? String(value)
        : "";
}
function yearText(value) {
    return parseAssetYear(value) === null ? "" : String(value);
}
function resourceToDraft(resource) {
    var _a;
    return {
        mediaResourceId: resource.mediaResourceId,
        type: resource.type,
        protocol: resource.protocol,
        url: (_a = resource.url) !== null && _a !== void 0 ? _a : "",
        isEncrypted: resource.isEncrypted === true,
    };
}
function mediaToDraft(media) {
    var _a, _b, _c, _d, _e, _f;
    return {
        mediaId: media.mediaId,
        type: media.type,
        name: (_a = media.name) !== null && _a !== void 0 ? _a : "",
        videoResolution: (_b = media.videoResolution) !== null && _b !== void 0 ? _b : "HD",
        durationMillis: numberText(media.durationMillis),
        videoWidth: numberText(media.videoWidth),
        videoHeight: numberText(media.videoHeight),
        multiChannelAudio: media.multiChannelAudio === true,
        spokenLanguage: (_c = media.spokenLanguage) !== null && _c !== void 0 ? _c : "",
        audioLanguages: ((_d = media.audioLanguages) !== null && _d !== void 0 ? _d : []).map((l) => l.language),
        subtitleLanguages: ((_e = media.subtitleLanguages) !== null && _e !== void 0 ? _e : []).map((l) => l.language),
        hardOfHearing: media.hardOfHearing === true,
        mediaResources: ((_f = media.mediaResources) !== null && _f !== void 0 ? _f : []).map(resourceToDraft),
    };
}
function rightsToDraft(rights) {
    var _a, _b, _c, _d;
    return {
        contentRightsId: rights.contentRightsId,
        marketCountry: (_a = rights.marketCountry) !== null && _a !== void 0 ? _a : "",
        region: (_b = rights.region) !== null && _b !== void 0 ? _b : WHOLE_MARKET,
        availableFrom: (_c = rights.availableFrom) !== null && _c !== void 0 ? _c : "",
        availableTo: (_d = rights.availableTo) !== null && _d !== void 0 ? _d : RIGHTS_OPEN_ENDED,
        encrypted: rights.encrypted === true,
        maxConcurrentStreams: numberText(rights.maxConcurrentStreams),
        allowedToDownload: rights.allowedToDownload === true,
    };
}
function imageToDraft(image) {
    var _a, _b, _c, _d;
    return {
        imageId: image.imageId,
        language: (_a = image.language) !== null && _a !== void 0 ? _a : "",
        type: (_b = image.type) !== null && _b !== void 0 ? _b : DEFAULT_IMAGE_TYPE,
        url: (_c = image.url) !== null && _c !== void 0 ? _c : "",
        source: (_d = image.source) !== null && _d !== void 0 ? _d : "",
        width: numberText(image.width),
        height: numberText(image.height),
    };
}
export function assetToDraft(asset) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return {
        assetId: asset.assetId,
        type: asset.type,
        sourceType: asset.sourceType,
        externalId: (_a = asset.externalId) !== null && _a !== void 0 ? _a : "",
        originalTitle: (_b = asset.originalTitle) !== null && _b !== void 0 ? _b : "",
        providerId: (_d = (_c = asset.provider) === null || _c === void 0 ? void 0 : _c.providerId) !== null && _d !== void 0 ? _d : "",
        originalLanguage: (_e = asset.originalLanguage) !== null && _e !== void 0 ? _e : "",
        countryOfOrigin: (_f = asset.countryOfOrigin) !== null && _f !== void 0 ? _f : "",
        copyrightInfo: (_g = asset.copyrightInfo) !== null && _g !== void 0 ? _g : "",
        eidrId: (_h = asset.eidrId) !== null && _h !== void 0 ? _h : "",
        studio: (_j = asset.studio) !== null && _j !== void 0 ? _j : "",
        productionYear: yearText(asset.productionYear),
        duration: numberText(asset.duration),
        seriesId: (_k = asset.seriesId) !== null && _k !== void 0 ? _k : "",
        seasonId: (_l = asset.seasonId) !== null && _l !== void 0 ? _l : "",
        seasonNumber: numberText(asset.seasonNumber),
        episodeNumber: numberText(asset.episodeNumber),
        keywords: [...((_m = asset.keywords) !== null && _m !== void 0 ? _m : [])],
        genreIds: ((_o = asset.genres) !== null && _o !== void 0 ? _o : []).map((g) => g.genreId),
        tagIds: ((_p = asset.tags) !== null && _p !== void 0 ? _p : []).map((t) => t.tagId),
        localizedInfo: ((_q = asset.localizedInfo) !== null && _q !== void 0 ? _q : []).map((row) => ({ ...row })),
        images: ((_r = asset.images) !== null && _r !== void 0 ? _r : []).map(imageToDraft),
        medias: ((_s = asset.medias) !== null && _s !== void 0 ? _s : []).map(mediaToDraft),
        contentRights: ((_t = asset.contentRights) !== null && _t !== void 0 ? _t : []).map(rightsToDraft),
        parentalRatings: ((_u = asset.parentalRatings) !== null && _u !== void 0 ? _u : []).map((r) => ({ ...r })),
        contributors: ((_v = asset.contributors) !== null && _v !== void 0 ? _v : []).map((c) => ({ ...c })),
    };
}
function intOrUndefined(value) {
    const trimmed = value.trim();
    if (trimmed === "")
        return undefined;
    const n = Number(trimmed);
    return Number.isFinite(n) ? Math.trunc(n) : undefined;
}
function intOrZero(value) {
    const n = intOrUndefined(value);
    return n === undefined ? 0 : n;
}
function trimmedList(values) {
    return values.map((v) => v.trim()).filter((v) => v !== "");
}
function mediaPayload(media) {
    return {
        ...(media.mediaId === null ? {} : { mediaId: media.mediaId }),
        type: media.type,
        name: media.name.trim(),
        videoResolution: media.videoResolution,
        durationMillis: intOrZero(media.durationMillis),
        ...(intOrUndefined(media.videoWidth) === undefined
            ? {}
            : { videoWidth: intOrUndefined(media.videoWidth) }),
        ...(intOrUndefined(media.videoHeight) === undefined
            ? {}
            : { videoHeight: intOrUndefined(media.videoHeight) }),
        multiChannelAudio: media.multiChannelAudio,
        spokenLanguage: media.spokenLanguage.trim(),
        audioLanguages: trimmedList(media.audioLanguages).map((language) => ({
            language,
        })),
        subtitleLanguages: trimmedList(media.subtitleLanguages).map((language) => ({
            language,
        })),
        hardOfHearing: media.hardOfHearing,
        mediaResources: media.mediaResources.map((resource) => ({
            ...(resource.mediaResourceId === null
                ? {}
                : { mediaResourceId: resource.mediaResourceId }),
            type: resource.type,
            protocol: resource.protocol,
            url: resource.url.trim(),
            isEncrypted: resource.isEncrypted,
        })),
    };
}
function rightsPayload(row) {
    var _a;
    return {
        ...(row.contentRightsId === null
            ? {}
            : { contentRightsId: row.contentRightsId }),
        marketCountry: row.marketCountry.trim().toLowerCase(),
        region: row.region.trim(),
        availableFrom: row.availableFrom,
        availableTo: row.availableTo,
        encrypted: row.encrypted,
        maxConcurrentStreams: (_a = intOrUndefined(row.maxConcurrentStreams)) !== null && _a !== void 0 ? _a : DEFAULT_MAX_CONCURRENT_STREAMS,
        allowedToDownload: row.allowedToDownload,
    };
}
function imagePayload(image, { allowImageId }) {
    var _a, _b;
    return {
        ...(allowImageId && image.imageId !== null
            ? { imageId: image.imageId }
            : {}),
        language: image.language.trim().toLowerCase(),
        type: image.type,
        url: image.url.trim(),
        source: image.source.trim(),
        width: (_a = intOrUndefined(image.width)) !== null && _a !== void 0 ? _a : 0,
        height: (_b = intOrUndefined(image.height)) !== null && _b !== void 0 ? _b : 0,
    };
}
function scalarPayload(draft) {
    const year = intOrUndefined(draft.productionYear);
    const duration = intOrUndefined(draft.duration);
    const seasonNumber = intOrUndefined(draft.seasonNumber);
    const episodeNumber = intOrUndefined(draft.episodeNumber);
    return {
        externalId: draft.externalId.trim(),
        originalTitle: draft.originalTitle.trim(),
        sourceType: draft.sourceType,
        ...(draft.providerId.trim()
            ? { provider: { providerId: draft.providerId.trim() } }
            : {}),
        ...(draft.originalLanguage.trim()
            ? { originalLanguage: draft.originalLanguage.trim() }
            : {}),
        ...(draft.countryOfOrigin.trim()
            ? { countryOfOrigin: draft.countryOfOrigin.trim() }
            : {}),
        ...(draft.copyrightInfo.trim()
            ? { copyrightInfo: draft.copyrightInfo.trim() }
            : {}),
        ...(draft.eidrId.trim() ? { eidrId: draft.eidrId.trim() } : {}),
        ...(draft.studio.trim() ? { studio: draft.studio.trim() } : {}),
        ...(year === undefined ? {} : { productionYear: year }),
        ...(duration === undefined ? {} : { duration }),
        ...(draft.seriesId.trim() ? { seriesId: draft.seriesId.trim() } : {}),
        ...(draft.seasonId.trim() ? { seasonId: draft.seasonId.trim() } : {}),
        ...(seasonNumber === undefined ? {} : { seasonNumber }),
        ...(episodeNumber === undefined ? {} : { episodeNumber }),
        ...(draft.genreIds.length
            ? { genres: trimmedList(draft.genreIds).map((genreId) => ({ genreId })) }
            : {}),
        ...(draft.tagIds.length
            ? { tags: trimmedList(draft.tagIds).map((tagId) => ({ tagId })) }
            : {}),
    };
}
function collectionPayloads(draft, { allowImageId }) {
    return {
        medias: draft.medias.map(mediaPayload),
        images: draft.images.map((image) => imagePayload(image, { allowImageId })),
        localizedInfo: draft.localizedInfo.map((row) => ({ ...row })),
        contentRights: draft.contentRights.map(rightsPayload),
        keywords: trimmedList(draft.keywords),
        contributors: draft.contributors.map((c) => ({ ...c })),
        parentalRatings: draft.parentalRatings.map((r) => ({ ...r })),
    };
}
export function draftToCreate(draft) {
    const collections = collectionPayloads(draft, { allowImageId: false });
    const body = {
        ...scalarPayload(draft),
        type: draft.type,
    };
    for (const key of REPLACED_COLLECTIONS) {
        const value = collections[key];
        if (value.length)
            body[key] = value;
    }
    return body;
}
function sameValue(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}
export function changedCollections(draft, original) {
    const next = collectionPayloads(draft, { allowImageId: true });
    const before = collectionPayloads(assetToDraft(original), {
        allowImageId: true,
    });
    return REPLACED_COLLECTIONS.filter((key) => !sameValue(next[key], before[key]));
}
export function emptiedCollections(draft, original) {
    const next = collectionPayloads(draft, { allowImageId: true });
    const before = collectionPayloads(assetToDraft(original), {
        allowImageId: true,
    });
    return REPLACED_COLLECTIONS.filter((key) => next[key].length === 0 && before[key].length > 0);
}
export function draftToUpdate(draft, original, options = {}) {
    const collections = collectionPayloads(draft, { allowImageId: true });
    const body = { ...scalarPayload(draft) };
    for (const key of changedCollections(draft, original)) {
        body[key] = collections[key];
    }
    if (options.confirmEmptyCollections)
        body.confirmEmptyCollections = true;
    return body;
}
export function draftRefusals(draft) {
    const out = [];
    if (!draft.externalId.trim()) {
        out.push({ field: "externalId", reason: "required" });
    }
    if (!draft.originalTitle.trim()) {
        out.push({ field: "originalTitle", reason: "required" });
    }
    draft.medias.forEach((media, mediaIndex) => {
        if (media.mediaResources.some((r) => r.url.trim() === "")) {
            out.push({ field: "resourceUrl", reason: "required", mediaIndex });
        }
    });
    draft.images.forEach((image, index) => {
        if (!image.language.trim()) {
            out.push({ field: "imageLanguage", reason: "required", index });
        }
    });
    return out;
}
export function draftAsAsset(draft, original) {
    var _a, _b, _c, _d, _e;
    const create = draftToCreate(draft);
    return {
        type: draft.type,
        ...((original === null || original === void 0 ? void 0 : original.alternativeIds)
            ? { alternativeIds: original.alternativeIds }
            : {}),
        medias: ((_a = create.medias) !== null && _a !== void 0 ? _a : []),
        images: ((_b = create.images) !== null && _b !== void 0 ? _b : []),
        localizedInfo: ((_c = create.localizedInfo) !== null && _c !== void 0 ? _c : []),
        contentRights: ((_d = create.contentRights) !== null && _d !== void 0 ? _d : []),
        genres: ((_e = draft.genreIds) !== null && _e !== void 0 ? _e : []).map((genreId) => ({
            genreId,
            name: genreId,
            localizedName: [],
        })),
        tags: [],
        keywords: trimmedList(draft.keywords),
        ...(intOrUndefined(draft.productionYear) === undefined
            ? {}
            : { productionYear: intOrUndefined(draft.productionYear) }),
        ...(intOrUndefined(draft.duration) === undefined
            ? {}
            : { duration: intOrUndefined(draft.duration) }),
    };
}
